const labelByItem = {
  partners: 'Partners',
  friends: 'Friends',
  tickets: 'Tickets',
  arena: 'Arena',
  shop: 'Shop',
  rollCraft: 'Games',
} as const;

export { labelByItem };
